import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const Tag = (props) => {
    const { color, tone, onRemove, ...safeProps } = props;
    return (
        <span
            {...safeProps}
            role={onRemove ? 'button' : props.role}
            onClick={onRemove || props.onClick}
            onKeyUp={(e) =>
                onRemove
                    ? e.keyCode === 32 && onRemove(e)
                    : props.onKeyUp && props.onKeyUp(e)
            }
            tabIndex={onRemove ? props.tabIndex || 0 : props.tabIndex}
            className={`tag tag--${color} tag--${tone} ${props.className}`}>
            {props.children}
            {onRemove && <Icon name="close" className="tag__remove" />}
        </span>
    );
};

Tag.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'primary',
        'secondary',
        'tertiary',
        'success',
        'error',
        'tan',
        'grey',
    ]),
    tone: PropTypes.oneOf(['light', 'normal', 'dark']),
    onRemove: PropTypes.func,
};

Tag.defaultProps = {
    className: '',
    color: 'primary',
    tone: 'normal',
};

export default Tag;
